import { Navigate, Outlet } from 'react-router-dom';
import React from 'react';

const ProtectedRoute = ({ isAllowed, redirectPath = '/unauthorized', children }: any) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
